import React from 'react';
import SummaryPage from './SummaryPage';
import Scene from '../../scene';

export interface Props {
  detailedSceneImage: string;
  captureScene: (scene: Scene) => typeof Scene;
}
const SummaryView: React.FC<Props> = ({ detailedSceneImage, captureScene }) => {
  const sceneRef = React.useRef<Scene | null>(null);

  React.useEffect(() => {
    if (!detailedSceneImage) {
      sceneRef.current = new Scene({
        onDragEnd: () => {},
        onDragStart: () => {},
        sceneRect: () => {},
        trashcanRect: { x: 0, y: 548, width: 789, height: 170 },
        viewRect: { x: 0, y: 1, width: 789, height: 798 },
      });

      captureScene(sceneRef.current);
    }
  }, []);

  return <SummaryPage detailedSceneImage={detailedSceneImage} />;
};

export default SummaryView;
